import { DemoVideoNotes, DemoVideoPlayer } from "@/components/DemoVideo";

export default function InAction() {
  return (
    <div className="p-6 lg:p-10 max-w-5xl space-y-6" data-testid="in-action-page">
      <div>
        <p className="font-mono text-xs uppercase tracking-widest text-orange-400 mb-2">Recorded internal test</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold">See RoofLead in Action</h1>
        <p className="text-slate-400 mt-3 max-w-2xl">From a missed call to a qualified lead in under a minute. Pause any time to answer questions.</p>
      </div>
      <DemoVideoPlayer />
      <DemoVideoNotes />
    </div>
  );
}
